import React, { FC, useState, useMemo, useCallback } from 'react'; //new
import { ICellRendererParams } from 'ag-grid-community';
import './ContextPage.scss';
import { Button,Tooltip} from '@scuf/common';
import { ERROR_MSG_FOR_USER_RESPONSE, RouteConstants, TabConstants } from 'src/constants/constants';//new
import ContextList from './ContextList';
import EditContextList from './EditContextList';
import { getCurrentRole } from '../../slices/onBoardingSlice';
import { useSelector } from 'react-redux';
import { USER_ROLE } from '../../constants/constants';
import { useNavigate } from 'react-router-dom'; //new

export const CustomOverlay: FC<
  ICellRendererParams & {
    noRecords: boolean;
    error: boolean;
    loading: boolean;
  }
> = ({ error, noRecords, loading }) => {
  if (loading) return <div>Loading...</div>;
  else if (error)
    return <div className='error-overlay'>{ERROR_MSG_FOR_USER_RESPONSE}</div>;
  else if (noRecords) return <div>No records to show</div>;
  else return null;
};

export const StatusRenderer = (params: ICellRendererParams) => {
  // return <span className={`status-dot ${params.value}`} />;
  return <span className={`status-dot orange`} />;
};

export const ContextPage = () => {
  const [showEdit, setShowEdit] = useState(false);
  const currentRole = useSelector(getCurrentRole);

  //new
  const navigate = useNavigate();
  const editButtonAction = () => {
    navigate(RouteConstants.CONTEXT_EDIT)
    setShowEdit((prevState) => !prevState)
  }
  //
  return (
    <div className='context-container'>
      <div className='context-edit-container'>



        {currentRole && (currentRole === USER_ROLE.MODEL_POWER_USER) && <>
         {
          !showEdit && <Tooltip 
         content="Please click here to view Create New Model User Guide"
         element={  <a className="tooltip-context-conatiner" href="https://honeywellprod.sharepoint.com/sites/DWP-Functions/finance/Corporate%20Audit/CAMS/PublishingImages/Pages/New-Model-Creation/Create-Model-User-Guide.pdf" target="_blank">
           <svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 50 50" width="30px" height="30px"><path d="M 25 2 C 12.309295 2 2 12.309295 2 25 C 2 37.690705 12.309295 48 25 48 C 37.690705 48 48 37.690705 48 25 C 48 12.309295 37.690705 2 25 2 z M 25 4 C 36.609824 4 46 13.390176 46 25 C 46 36.609824 36.609824 46 25 46 C 13.390176 46 4 36.609824 4 25 C 4 13.390176 13.390176 4 25 4 z M 25 11 A 3 3 0 0 0 22 14 A 3 3 0 0 0 25 17 A 3 3 0 0 0 28 14 A 3 3 0 0 0 25 11 z M 21 21 L 21 23 L 22 23 L 23 23 L 23 36 L 22 36 L 21 36 L 21 38 L 22 38 L 23 38 L 27 38 L 28 38 L 29 38 L 29 36 L 28 36 L 27 36 L 27 21 L 26 21 L 22 21 L 21 21 z"/></svg>
             </a>
          }
          position="top right" 
         
        ></Tooltip>
         } 
        <Button
          className='context-edit-btn custom-btn'
          content={showEdit ? 'Back' : 'Edit'}
          size='small'
          textTransform={false}
          onClick={() => editButtonAction()}></Button> 
          </>
        }

      </div>
      {!showEdit && <ContextList />}
      {/* {showEdit && <EditContextList />} */} 
      {/* new */}
    </div>
  );
};
export default ContextPage;
